<template>
    <VerticalSlideTransition :show="!!errorMessage">
        <p class="text-sm text-danger">
            {{ errorMessage }}
        </p>
    </VerticalSlideTransition>
</template>

<script>
import VerticalSlideTransition from '@/Components/Transitions/VerticalSlideTransition.vue'

export default {
    name: 'InputError',

    components: {
        VerticalSlideTransition,
    },

    props: {
        message: {
            type: [String, Array],
            default: null,
        },
    },

    computed: {
        errorMessage() {
            if (this.message) {
                if (Array.isArray(this.message)) {
                    return this.message.join(', ')
                }

                return this.message
            }
        },
    },
}
</script>
